// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1nE54","approved":"Status_approved__1siid","rejected":"Status_rejected__1lSEt","expired":"Status_expired__1qchG","label":"Status_label__3Q68o"};